import actions from './constants';

export const fetchDatasetMetrics = (category, code) => ({
  type: actions.FETCH_DATASET_METRICS,
  category,
  code,
});

export const fetchDatasetMetricsSuccess = (category, code, result) => ({
  type: actions.FETCH_DATASET_METRICS_SUCCESS,
  category,
  code,
  result,
});

export const fetchDatasetMetricsError = (category, code, error) => ({
  type: actions.FETCH_DATASET_METRICS_ERROR,
  category,
  code,
  error,
});
